import { useQuery } from '@tanstack/react-query';
import { IMetadataLogin } from '../Interfaces/IMetadataLogin';
import { customFetcher } from './useFetch';
import { IDocumentRequested } from '../Interfaces/IDocumentRequested';
import { IDocumentUploaded } from '../Interfaces/IDocumentUploaded';

export const useGetMetadataLogin = () => {
  const {
    data: metadataLoginArray,
    isLoading: isLoadingMetadataLoginArray,
    refetch: refetchMetadataLoginArray,
  } = useQuery<IMetadataLogin[]>({
    queryKey: ['metadatalogin'],
    queryFn: () =>
      customFetcher({
        endpoint: '/metadatalogin',
      }),
  });

  return {
    metadataLoginArray,
    isLoadingMetadataLoginArray,
    refetchMetadataLoginArray,
  };
};

export const useGetDocumentRequested = () => {
  const {
    data: documentRequestedArray,
    isLoading: isLoadingDocumentRequestedArray,
    refetch: refetchDocumentRequestedArray,
  } = useQuery<IDocumentRequested[]>({
    queryKey: ['documentrequested'],
    queryFn: () =>
      customFetcher({
        endpoint: '/documentrequested',
      }),
  });

  return {
    documentRequestedArray,
    isLoadingDocumentRequestedArray,
    refetchDocumentRequestedArray,
  };
};

export const useGetDocumentUploaded = () => {
  const {
    data: documentUploadedArray,
    isLoading: isLoadingDocumentUploadedArray,
    refetch: refetchDocumentUploadedArray,
  } = useQuery<IDocumentUploaded[]>({
    queryKey: ['documentuploaded'],
    queryFn: () =>
      customFetcher({
        endpoint: '/documentuploaded',
      }),
  });

  return {
    documentUploadedArray,
    isLoadingDocumentUploadedArray,
    refetchDocumentUploadedArray,
  };
};
